/*
 * Core Util JS
 *
 * @author				Matt Gifford
 * @copyright			2020 Brigada Limited
 */
define("brigada/jquery", [], () => {
	if (typeof window.__jQueryBrigada == 'undefined') {
		window.__jQueryBrigada = jQuery;
	}

	// Return the conflict jQuery loaded with the theme
	return !!window.__jQueryBrigada ? __jQueryBrigada : jQuery;
});
